import React from "react";
import { useChannelStateContext } from "stream-chat-react";
import { Check, ChevronDown, Sparkles } from "lucide-react";
import { useUpdateChannelMetadata } from "@/components/pages/chats/component/hooks/useUpdateChannelMetadata";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const AIChatSettingsSelect = () => {
  const { t } = useTranslation();
  const { channel } = useChannelStateContext();
  const { updateMetadata } = useUpdateChannelMetadata();

  const muteAutoResponses = !!channel?.data?.muteAutoResponses;

  const handleValueChange = async (value: string) => {
    const isMuted = value === "mute";
    await updateMetadata({
      muteAutoResponses: isMuted,
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex h-8 w-16 items-stretch overflow-hidden rounded-[8px] border border-violet-300 bg-white shadow-sm transition-colors hover:border-violet-400"
        >
          <span className="relative flex w-8 items-center justify-center text-[#7d7aa5]">
            <span className="relative inline-flex h-5 w-5 items-center justify-center">
              <Sparkles className="h-5 w-5" />
              <span
                className={`absolute -top-0.5 -right-1 h-2 w-2 rounded-full ring-2 ring-white ${
                  muteAutoResponses ? "bg-slate-400" : "bg-emerald-400"
                }`}
              />
            </span>
          </span>
          <span className="w-px bg-violet-300" />
          <span className="flex w-8 items-center justify-center text-[#7d7aa5]">
            <ChevronDown className="h-5 w-5" />
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[260px] rounded-2xl p-2"
      >
        <DropdownMenuItem
          className="rounded-xl px-3 py-3 text-base"
          onClick={() => handleValueChange("unmute")}
        >
          {t("chats.ai.cannedReplies", "Canned replies")}
          {!muteAutoResponses && <Check className="ml-auto h-5 w-5" />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="rounded-xl px-3 py-3 text-base"
          onClick={() => handleValueChange("mute")}
        >
          {t("chats.ai.muteAutoResponses", "Mute auto-responses")}
          {muteAutoResponses && <Check className="ml-auto h-5 w-5" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
